<div *ngIf="!!orderhead" class="col-xs-12 sp-0 tt-order-head-dynamic-special__cols">
    <div class="tt-order-head-dynamic-special__col">
        <tt-card ttHeading="h_orderer">
            <tt-field-group>
                <tt-input class="col-3" ttLabel="orderhead_stat_cust_no" ttLabelView="top" [(ttModel)]="orderhead.stat_cust_no" ttReadonly style="min-width: 12rem"></tt-input>
                <tt-search
                    class="col-9"
                    ttLabel="stat_cust_name"
                    ttLabelView="top"
                    [(ttModel)]="orderhead.stat_cust_name"
                    [ttSearch]="searchCustomer"
                    (ttOnSelected)="onStatCustomerSelected($event)"
                    (ttOnClear)="onStatCustomerSelected()"
                ></tt-search>
            </tt-field-group>
            <tt-select
                ttLabel="stat_coop"
                ttLabelView="top"
                [(ttModel)]="orderhead.stat_coop_id"
                tt-change="vm.onOrderheadChanged($value, $modelId)"
                (ttModelChange)="onDynamicSpecialChange('stat_coop_id')"
                [ttData]="coops"
                ttDataId="coop_id"
                ttDataName="coop_name"
            ></tt-select>
            <tt-select
                ttLabel="seller"
                ttLabelView="top"
                [(ttModel)]="orderhead.seller_no"
                tt-change="vm.onOrderheadChanged($value, $modelId)"
                (ttModelChange)="onDynamicSpecialChange('seller_no')"
                [ttData]="sellers"
            ></tt-select>
            <tt-field-group>
                <tt-select
                    class="col-7"
                    ttLabel="contact_person"
                    ttLabelView="top"
                    [(ttModel)]="orderhead.contact_pers_no"
                    (ttModelChange)="onDynamicSpecialChange('contact_pers_no')"
                    tt-change="vm.onOrderheadChanged($value, $modelId)"
                    [ttData]="customerPersons"
                ></tt-select>
                <tt-input
                    class="col-5"
                    ttLabel="telephone"
                    ttLabelView="top"
                    [(ttModel)]="orderhead.cust_contact_phone"
                    (ttModelChange)="onDynamicSpecialChange('cust_contact_phone')"
                    tt-change="vm.onOrderheadChanged($value, $modelId)"
                ></tt-input>
            </tt-field-group>
            <tt-select
                ttLabel="contact_person2"
                ttLabelView="top"
                [(ttModel)]="orderhead.contact_pers_no2"
                (ttModelChange)="onDynamicSpecialChange('contact_pers_no2')"
                tt-change="vm.onOrderheadChanged($value, $modelId)"
                [ttData]="customerPersons"
            ></tt-select>
            <tt-select
                ttLabel="discount2"
                ttLabelView="top"
                [(ttModel)]="orderhead.special_discount2_keyno"
                (ttModelChange)="onDynamicSpecialChange('special_discount2_keyno')"
                tt-change="vm.onOrderheadChanged($value, $modelId)"
                [ttData]="specialDiscount2"
                ttDataId="special_discount2_keyno"
                ttDataName="discount_name"
                ttShowClearButton
            ></tt-select>
            <tt-input ttLabel="edi_description" ttLabelView="top" [(ttModel)]="orderhead.edi_description" (ttModelChange)="onDynamicSpecialChange('edi_description')"></tt-input>
        </tt-card>

        <tt-card ttHeading="orderinfo">
            <tt-field-group>
                <tt-date class="col-4" ttLabel="orderdate" ttLabelView="top" [(ttModel)]="orderhead.order_date" (ttModelChange)="onDynamicSpecialChange('order_date')"></tt-date>
                <tt-input class="col-8" ttLabel="ordertype" ttLabelView="top" [ttModel]="orderhead.ordertype_name" ttReadonly ttTabable="false"></tt-input>
            </tt-field-group>
            <tt-date ttLabel="deliverydate_wish" ttLabelView="top" [(ttModel)]="orderhead.deliverydate_wish" (ttModelChange)="onDynamicSpecialChange('deliverydate_wish')"></tt-date>
            <tt-field-group>
                <tt-input class="col-4" ttLabel="orderstatus" ttLabelView="top" [ttModel]="orderhead.orderstatus_name" ttReadonly ttTabable="false"></tt-input>
                <tt-date
                    class="col-8"
                    ttLabel="confirmed"
                    ttLabelView="top"
                    [(ttModel)]="orderhead.deliverydate_confirmed"
                    (ttModelChange)="onDynamicSpecialChange('deliverydate_confirmed')"
                ></tt-date>
            </tt-field-group>
            <tt-input
                *ngIf="orderhead.show_original_order_internal_no === '1'"
                ttLabel="original_order_internal_no"
                ttLabelView="top"
                [(ttModel)]="orderhead.original_order_internal_no"
                (ttModelChange)="onDynamicSpecialChange('original_order_internal_no')"
            >
                <tt-form-field-button
                    buttons
                    *ngIf="orderhead.original_order_internal_no > '0'"
                    ttGoto="orderhead"
                    [ttGotoParms]="{ order_internal_no: orderhead.original_order_internal_no }"
                ></tt-form-field-button>
            </tt-input>
            <tt-checkbox
                ttLabel="approved_production"
                ttLabelView="top"
                [(ttModel)]="orderhead.production_date_confirmed"
                (ttModelChange)="onDynamicSpecialChange('production_date_confirmed')"
            ></tt-checkbox>
            <tt-date
                *ngIf="orderhead.production_date_confirmed === '1'"
                ttLabel="production_date"
                ttLabelView="top"
                [(ttModel)]="orderhead.production_date"
                (ttModelChange)="onDynamicSpecialChange('production_date')"
            ></tt-date>
            <tt-checkbox
                ttLabel="approved_transport"
                ttLabelView="top"
                [(ttModel)]="orderhead.tranportation_date_confirmed"
                (ttModelChange)="onDynamicSpecialChange('tranportation_date_confirmed')"
            ></tt-checkbox>
            <tt-checkbox ttLabel="creditstop" ttLabelView="top" [(ttModel)]="orderhead.locked" (ttModelChange)="onDynamicSpecialChange('locked')"></tt-checkbox>
            <tt-date
                *ngIf="orderhead.tranportation_date_confirmed === '1'"
                ttLabel="transport_date"
                ttLabelView="top"
                [(ttModel)]="orderhead.tranportation_date"
                (ttModelChange)="onDynamicSpecialChange('tranportation_date')"
            ></tt-date>
        </tt-card>
        <tt-card ttHeading="changes">
            <tt-field-group>
                <tt-date class="col-3" ttLabel="registered_date" ttLabelView="top" [ttModel]="orderhead.registered_date" ttReadonly ttTabable="false" style="min-width: 10rem"></tt-date>
                <tt-input class="col-3" ttLabel="registered_time" ttLabelView="top" [ttModel]="orderhead.registered_time" ttReadonly ttTabable="false" style="min-width: 10rem"></tt-input>
                <tt-input class="col-6" ttLabel="regbyusername" ttLabelView="top" [ttModel]="orderhead.regbyusername" ttReadonly ttTabable="false"></tt-input>
            </tt-field-group>
            <tt-field-group>
                <tt-date class="col-3" ttLabel="modified_date" ttLabelView="top" [ttModel]="orderhead.modified_date" ttReadonly ttTabable="false" style="min-width: 10rem"></tt-date>
                <tt-input class="col-3" ttLabel="modified_time" ttLabelView="top" [ttModel]="orderhead.modified_time" ttReadonly ttTabable="false" style="min-width: 10rem"></tt-input>
                <tt-input class="col-6" ttLabel="modifiedbyusername" ttLabelView="top" [ttModel]="orderhead.modifiedbyusername" ttReadonly ttTabable="false"></tt-input>
            </tt-field-group>
        </tt-card>
    </div>
    <div class="tt-order-head-dynamic-special__col">
        <tt-card ttHeading="delivery">
            <tt-checkbox ttLabel="flexible_delivery" ttLabelView="top" [(ttModel)]="orderhead.flexible_delivery_date" (ttModelChange)="onDynamicSpecialChange('flexible_delivery_date')"></tt-checkbox>
            <tt-input ttLabel="project" ttLabelView="top" [(ttModel)]="orderhead.delivery_cust_name" (ttModelChange)="onDynamicSpecialChange('delivery_cust_name')"></tt-input>
            <tt-input ttLabel="delivery_address" ttLabelView="top" [(ttModel)]="orderhead.delivery_adr_street" (ttModelChange)="onDynamicSpecialChange('delivery_adr_street')"></tt-input>
            <tt-field-group>
                <tt-search
                    class="col-4"
                    ttLabel="delivery_postplace_id_street"
                    ttLabelView="top"
                    [(ttModel)]="orderhead.delivery_postplace_id_street"
                    (ttModelChange)="onDynamicSpecialChange('delivery_postplace_id_street')"
                    ttMinLength="1"
                    [ttSearch]="searchPostplaces"
                    ttDataId="postplace_id"
                    ttDataName="postplace_keyname"
                    (ttOnSelected)="onPostplaceSelected($event)"
                    (ttOnClear)="onPostplaceSelected()"
                    style="min-width: 12rem"
                ></tt-search>
                <tt-search
                    class="col-8"
                    ttLabel="delivery_postplace_name_street"
                    ttLabelView="top"
                    [(ttModel)]="orderhead.delivery_postplace_name_street"
                    (ttModelChange)="onDynamicSpecialChange('delivery_postplace_name_street')"
                    ttMinLength="1"
                    [ttSearch]="searchPostplaces"
                    ttDataId="postplace_id"
                    ttDataName="postplace_keyname"
                    (ttOnSelected)="onPostplaceSelected($event)"
                    (ttOnClear)="onPostplaceSelected()"
                ></tt-search>
            </tt-field-group>
            <tt-input ttLabel="label" ttLabelView="top" [(ttModel)]="orderhead.label" (ttModelChange)="onDynamicSpecialChange('label')"></tt-input>
            <tt-field-group>
                <tt-input
                    class="col-7"
                    ttLabel="contact_person"
                    ttLabelView="top"
                    [(ttModel)]="orderhead.contactperson"
                    (ttModelChange)="onDynamicSpecialChange('contactperson')"
                    tt-change="vm.onOrderheadChanged($value, $modelId)"
                ></tt-input>
                <tt-input
                    class="col-5"
                    ttLabel="telephone"
                    ttLabelView="top"
                    [(ttModel)]="orderhead.delivery_cust_phone"
                    (ttModelChange)="onDynamicSpecialChange('delivery_cust_phone')"
                    tt-change="vm.onOrderheadChanged($value, $modelId)"
                    ttPlaceholder="telephone"
                ></tt-input>
            </tt-field-group>
            <tt-input ttLabel="message_from_sales" ttLabelView="top" [(ttModel)]="orderhead.message_to_driver" (ttModelChange)="onDynamicSpecialChange('message_to_driver')"></tt-input>
            <tt-select
                ttLabel="stockplace"
                ttLabelView="top"
                [(ttModel)]="orderhead.stockplace_id"
                (ttModelChange)="onDynamicSpecialChange('stockplace_id')"
                tt-change="vm.onOrderheadChanged($value, $modelId)"
                [ttData]="stockplaces"
                ttDataId="stockplace_id"
                ttDataName="stockplace_name"
            ></tt-select>

            <tt-field-container class="col-xs-12 sp-0">
                <tt-field-group>
                    <tt-checkbox
                        class="col-6"
                        ttLabel="get_self"
                        ttLabelView="top"
                        [(ttModel)]="orderhead.customer_self_pickup"
                        (ttModelChange)="onCustomerSelfPickupChange()"
                        tt-change="vm.checkboxChecker($value, $modelId)"
                    ></tt-checkbox>
                    <tt-checkbox
                        class="col-6"
                        ttLabelView="top"
                        ttLabel="delivered_to_customer_stock"
                        [(ttModel)]="orderhead.deliver_to_customer_stock"
                        (ttModelChange)="onDeliverToCustomerStockChange()"
                        tt-change="vm.checkboxChecker($value, $modelId)"
                    ></tt-checkbox>
                </tt-field-group>
            </tt-field-container>
            <tt-field-container class="col-xs-12 sp-0">
                <tt-field-group>
                    <tt-checkbox
                        class="col-6"
                        ttLabelView="top"
                        ttLabel="direct_delivery_xps"
                        [(ttModel)]="orderhead.special_construction06"
                        (ttModelChange)="onConstruction06Change()"
                        tt-change="vm.checkboxChecker($value, $modelId)"
                    ></tt-checkbox>
                    <tt-checkbox
                        class="col-6"
                        ttLabelView="top"
                        ttLabel="direct_delivery_other"
                        [(ttModel)]="orderhead.special_construction07"
                        (ttModelChange)="onConstruction07Change()"
                        tt-change="vm.checkboxChecker($value, $modelId)"
                    ></tt-checkbox>
                </tt-field-group>
            </tt-field-container>
            <tt-field-container class="col-xs-12 sp-0">
                <tt-field-group>
                    <tt-checkbox
                        class="col-6"
                        ttLabelView="top"
                        ttLabel="special_construction01"
                        [(ttModel)]="orderhead.special_construction01"
                        (ttModelChange)="onDynamicSpecialChange('special_construction01')"
                    ></tt-checkbox>
                    <tt-checkbox
                        class="col-6"
                        ttLabelView="top"
                        ttLabel="special_construction02"
                        [(ttModel)]="orderhead.special_construction02"
                        (ttModelChange)="onDynamicSpecialChange('special_construction02')"
                    ></tt-checkbox>
                </tt-field-group>
                <tt-field-group>
                    <tt-checkbox
                        class="col-6"
                        ttLabelView="top"
                        ttLabel="special_construction03"
                        [(ttModel)]="orderhead.special_construction03"
                        (ttModelChange)="onDynamicSpecialChange('special_construction03')"
                    ></tt-checkbox>
                    <tt-checkbox
                        class="col-6"
                        ttLabelView="top"
                        ttLabel="special_construction04"
                        [(ttModel)]="orderhead.special_construction04"
                        (ttModelChange)="onDynamicSpecialChange('special_construction04')"
                    ></tt-checkbox>
                </tt-field-group>
                <tt-field-group>
                    <tt-checkbox
                        class="col-6"
                        ttLabelView="top"
                        ttLabel="special_construction05"
                        [(ttModel)]="orderhead.special_construction05"
                        (ttModelChange)="onDynamicSpecialChange('special_construction05')"
                    ></tt-checkbox>
                    <tt-checkbox
                        class="col-6"
                        ttLabelView="top"
                        ttLabel="unmanned_constructionsite"
                        [(ttModel)]="orderhead.unmanned_contructionsite"
                        (ttModelChange)="onDynamicSpecialChange('unmanned_contructionsite')"
                    ></tt-checkbox>
                </tt-field-group>
                <tt-field-group>
                    <tt-time class="col-6" ttLabelView="top" ttLabel="time_start" [(ttModel)]="orderhead.dlv_time_from" (ttModelChange)="onDynamicSpecialChange('dlv_time_from')"></tt-time>
                    <tt-time class="col-6" ttLabelView="top" ttLabel="time_end" [(ttModel)]="orderhead.dlv_time_to" (ttModelChange)="onDynamicSpecialChange('dlv_time_to')"></tt-time>
                </tt-field-group>
            </tt-field-container>
        </tt-card>
        <tt-card ttHeading="note">
            <tt-textarea ttLabel="tt_note" ttLabelView="none" [(ttModel)]="orderhead.internal_note" (ttModelChange)="onDynamicSpecialChange('internal_note')"></tt-textarea>
        </tt-card>
    </div>
    <div class="tt-order-head-dynamic-special__col">
        <tt-card ttHeading="calc">
            <tt-field-group>
                <tt-input-number class="col-8" ttLabel="amount" ttLabelView="top" [ttModel]="orderhead.amount_total" ttDecimals="2" ttReadonly ttTabable="false"></tt-input-number>
                <tt-input-number class="col-4" ttLabel="amount_pst" ttLabelView="top" [ttModel]="orderhead.amount_total_pst" ttDecimals="2" ttReadonly ttTabable="false"></tt-input-number>
            </tt-field-group>
            <tt-field-group>
                <tt-input-number class="col-8" ttLabel="cost" ttLabelView="top" [ttModel]="orderhead.cost_total" ttDecimals="2" ttReadonly ttTabable="false"></tt-input-number>
                <tt-input-number class="col-4" ttLabel="cost_pst" ttLabelView="top" [ttModel]="orderhead.cost_total_pst" ttDecimals="2" ttReadonly ttTabable="false"></tt-input-number>
            </tt-field-group>
            <tt-field-group>
                <tt-input-number class="col-8" ttLabel="db2" ttLabelView="top" [ttModel]="orderhead.margin" ttDecimals="2" ttReadonly ttTabable="false"></tt-input-number>
                <tt-input-number class="col-4" ttLabel="sb2_pst" ttLabelView="top" [ttModel]="orderhead.margin_pst" ttDecimals="2" ttReadonly ttTabable="false"></tt-input-number>
            </tt-field-group>
        </tt-card>
        <tt-card ttHeading="cust_note" ttAccordion>
            <tt-textarea ttLabel="cust_note" ttLabelView="none" [ttModel]="orderhead.cust_note" ttReadonly></tt-textarea>
        </tt-card>
        <tt-card ttHeading="tt_dialog">
            <tt-orderhead-dialog [orderInternalNo]="orderhead.order_internal_no" (openDialog)="openDialog.emit($event)" [dialog]="dialog" dialogAsInput></tt-orderhead-dialog>
            <tt-button ttText="confirm_rx_order" (ttClick)="confirmOrder()" ttType="secondary" [ttLoading]="confirming"></tt-button>
            <tt-button ttText="picklist" (ttClick)="picklist()" ttType="secondary" [ttLoading]="callPicklist"></tt-button>
            <!-- <tt-button-save *ngIf="showSaveButton" ttText="save" (ttClick)="save()" [ttLoading]="saving"></tt-button-save> -->
        </tt-card>
    </div>
</div>
